
  import {
    Vue,
    Component,
    Watch,
    Ref,
    Prop,
  } from 'vue-property-decorator';
  import {
    Dialog,
    Button,
    Row,
    Col,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Table,
    TableColumn,
    InputNumber,
    Card,
    Checkbox,
    RadioGroup,
    Radio,
  } from 'element-ui';
  import worIndex from "../../wor/index.vue";
  import examApi from '@/api/exam';

  @Component({
    components: {
      Dialog,
      Button,
      Row,
      Col,
      Form,
      FormItem,
      worIndex,
      Input,
      Select,
      Option,
      Table,
      TableColumn,
      InputNumber,
      Card,
      Checkbox,
      RadioGroup,
      Radio,
    },
  })

    export default class paperDetail extends Vue {

      mounted() {
        let id: string = this.$route.params.pid;
        // examApi.quesBankDetail(id).then((res: any) => {
        //   console.log(res);
        // })
      }

    }
